export default "__VITE_ASSET__Dwd_ka6c__"